export const API_PORT = '3000';
export const API_URL = `http://localhost:${API_PORT}/api`;
export const DOMAIN_TITLE = 'Money-Plan.ua';
